import { useNavigate } from 'react-router-dom'

import { SettingsIcon, CreateIcon } from '@clara/icons'
import { useT } from '@clara/locale'
import { Flex, IconButton, Button } from '@clara/ui'

import { useGlobalStateContext } from '@/store/global/use-global-state'
import { useSidePanelContext } from '@clara/layout-next'

import { getSettingsSidePanel } from '../settings/sidepanel'
import { getBankInfoSidePanel } from '../bank-info/sidepanel'
import { useEvents } from '@/hooks/use-analytics'

export const LayoutButtons = () => {
  const { t } = useT('reimbursements')
  const navigate = useNavigate()
  const sidePanel = useSidePanelContext()

  const {
    getBankInfo,
    bankInfo,
    isCompanyOwner,
    canPay,
    userInfoResponse,
    isManagerOrCompanyOwner,
  } = useGlobalStateContext()

  const events = useEvents()

  const handleSettingsClick = () => {
    if (isCompanyOwner || canPay) {
      sidePanel.onOpen(
        getSettingsSidePanel({
          getBankInfo,
          bankInfo,
          isCompanyOwner,
          userInfoResponse,
        }),
      )
    } else {
      sidePanel.onOpen(
        getBankInfoSidePanel({
          getBankInfo,
          bankInfo,
          userInfoResponse,
        }),
      )
    }
  }

  const handleNewRequestClick = () => {
    events.creatingNewReimb()

    if (isManagerOrCompanyOwner && !bankInfo) {
      events.linkingAccount()

      sidePanel.onOpen(
        getBankInfoSidePanel({
          getBankInfo,
          bankInfo,
          userInfoResponse,
          isManagerOrCompanyOwner,
        }),
      )
    } else {
      navigate('/reimbursements/create')
    }
  }

  return (
    <Flex mt={1} gap={2}>
      <IconButton
        aria-label="Bank info settings"
        onClick={() => handleSettingsClick()}
      >
        <SettingsIcon />
      </IconButton>
      <Button onClick={() => handleNewRequestClick()} leftIcon={<CreateIcon />}>
        {t('main.actions.add.request')}
      </Button>
    </Flex>
  )
}
